import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mssidcproposalpage',
  templateUrl: './mssidcproposalpage.component.html',
  styleUrl: './mssidcproposalpage.component.css'
})
export class MssidcproposalpageComponent {
  constructor(private router: Router) { }

  VerifyProposal() {
    this.router.navigate(['/mssidcverifypoposal']);
  }
}
